// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0cf7c1cc","94":"73ca79ff","364":"1512e933","488":"2b665658","616":"fe2a01e4","803":"11fcc238","907":"fe8dba3b"}[chunkId] + ".chunk.js";
};